var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailing116X116(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "116px",
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/mailing/116x116") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/mailing/116x116",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "white-circle",
    fill: "#FFFFFF",
    cx: 58.5,
    cy: 58.5,
    r: 52.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5, 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "white-circle",
    fill: "#FFFFFF",
    cx: 52.5,
    cy: 52.5,
    r: 52.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7, 9)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(0, 42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.681166,0.329677583 L0.935136845,11.3938674 C0.359682012,11.700744 0,12.3017031 0,12.9563975 L0,40.7297348 C0,41.8515981 0.627487739,42.8780537 1.62320835,43.3854328 L21.967165,53.7516109 C22.6163028,54.0824308 23.3835153,54.0824308 24.0324711,53.7516109 L44.3766097,43.3854328 C45.3723303,42.8780537 45.9998181,41.8514154 45.9998181,40.7297348 L45.9998181,12.9563975 C45.9998181,12.3017031 45.6401361,11.700744 45.0644993,11.3938674 L24.3186521,0.329677583 C23.4941307,-0.109892528 22.5058693,-0.109892528 21.681166,0.329677583 Z",
    id: "Path",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,54 C23.3540421,54 23.7082661,53.9173864 24.0326531,53.7519764 L44.3767916,43.3857983 C45.3725123,42.8784193 46,41.8517809 46,40.7301003 L46,12.9563975 C46,12.66725 45.926499,12.390531 45.7985999,12.1430558 L23,24.3419031 L23,54 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24.3419031 L0.201582028,12.142873 C0.0735010283,12.3903482 0,12.6670672 0,12.9562148 L0,40.7297348 C0,41.8515981 0.627487739,42.8780537 1.62320835,43.3854328 L21.967165,53.7516109 C22.2917339,53.9170209 22.645776,53.9996345 23,53.9996345 L23,24.3419031 L23,24.3419031 Z",
    id: "Path",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1282313,3.96120295 L8.05509413,16.305538 L8.05509413,20.2554546 C8.05509413,20.6345267 8.26322576,20.9827101 8.59616358,21.161097 L12.6059722,23.3081365 C12.9241734,23.4784814 13.3082345,23.2469074 13.3082345,22.8846505 L13.3082345,19.1981103 L36.4172125,6.78194537 L31.1282313,3.96120295 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.3237, 40.1102)",
    fill: "#F41381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.00809324 L6.15534726,3.0506363 C6.94348204,2.67211251 7.43706692,1.86407116 7.41632653,0.986758672 L7.41578073,0.959342657 C7.39867901,0.235559856 6.63383167,-0.221190957 5.99269894,0.10962896 L0.000181933238,3.20142438 L0.000181933238,6.00809324 L0,6.00809324 L0,6.00809324 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.3204497 L3.38013764,8.74293214 C4.18046195,8.36916047 4.68459896,7.55472204 4.66367663,6.66827089 L4.66367663,6.66827089 C4.64657491,5.94192926 3.87736118,5.48536122 3.23586458,5.82093324 L0,7.51341525 L0,10.3204497 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.0549122,16.3451998 L8.0549122,20.2554546 C8.0549122,20.6345267 8.26304382,20.9827101 8.59598165,21.161097 L12.6057902,23.3081365 C12.9239915,23.4784814 13.3080525,23.2469074 13.3080525,22.8846505 L13.3080525,19.1981103 L13.3471682,19.1770914 C11.9890365,18.4503842 9.78309603,17.2698506 8.0549122,16.3451998 Z",
    id: "Path",
    fill: "#07A0C9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "package-copy",
    transform: "translate(46, 42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.681166,0.329677583 L0.935136845,11.3938674 C0.359682012,11.700744 0,12.3017031 0,12.9563975 L0,40.7297348 C0,41.8515981 0.627487739,42.8780537 1.62320835,43.3854328 L21.967165,53.7516109 C22.6163028,54.0824308 23.3835153,54.0824308 24.0324711,53.7516109 L44.3766097,43.3854328 C45.3723303,42.8780537 45.9998181,41.8514154 45.9998181,40.7297348 L45.9998181,12.9563975 C45.9998181,12.3017031 45.6401361,11.700744 45.0644993,11.3938674 L24.3186521,0.329677583 C23.4941307,-0.109892528 22.5058693,-0.109892528 21.681166,0.329677583 Z",
    id: "Path",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,54 C23.3540421,54 23.7082661,53.9173864 24.0326531,53.7519764 L44.3767916,43.3857983 C45.3725123,42.8784193 46,41.8517809 46,40.7301003 L46,12.9563975 C46,12.66725 45.926499,12.390531 45.7985999,12.1430558 L23,24.3419031 L23,54 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24.3419031 L0.201582028,12.142873 C0.0735010283,12.3903482 0,12.6670672 0,12.9562148 L0,40.7297348 C0,41.8515981 0.627487739,42.8780537 1.62320835,43.3854328 L21.967165,53.7516109 C22.2917339,53.9170209 22.645776,53.9996345 23,53.9996345 L23,24.3419031 L23,24.3419031 Z",
    id: "Path",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1282313,3.96120295 L8.05509413,16.305538 L8.05509413,20.2554546 C8.05509413,20.6345267 8.26322576,20.9827101 8.59616358,21.161097 L12.6059722,23.3081365 C12.9241734,23.4784814 13.3082345,23.2469074 13.3082345,22.8846505 L13.3082345,19.1981103 L36.4172125,6.78194537 L31.1282313,3.96120295 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.3237, 40.1102)",
    fill: "#F41381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.00809324 L6.15534726,3.0506363 C6.94348204,2.67211251 7.43706692,1.86407116 7.41632653,0.986758672 L7.41578073,0.959342657 C7.39867901,0.235559856 6.63383167,-0.221190957 5.99269894,0.10962896 L0.000181933238,3.20142438 L0.000181933238,6.00809324 L0,6.00809324 L0,6.00809324 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.3204497 L3.38013764,8.74293214 C4.18046195,8.36916047 4.68459896,7.55472204 4.66367663,6.66827089 L4.66367663,6.66827089 C4.64657491,5.94192926 3.87736118,5.48536122 3.23586458,5.82093324 L0,7.51341525 L0,10.3204497 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.0549122,16.3451998 L8.0549122,20.2554546 C8.0549122,20.6345267 8.26304382,20.9827101 8.59598165,21.161097 L12.6057902,23.3081365 C12.9239915,23.4784814 13.3080525,23.2469074 13.3080525,22.8846505 L13.3080525,19.1981103 L13.3471682,19.1770914 C11.9890365,18.4503842 9.78309603,17.2698506 8.0549122,16.3451998 Z",
    id: "Path",
    fill: "#07A0C9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "package-copy-2",
    transform: "translate(23, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.681166,0.329677583 L0.935136845,11.3938674 C0.359682012,11.700744 0,12.3017031 0,12.9563975 L0,40.7297348 C0,41.8515981 0.627487739,42.8780537 1.62320835,43.3854328 L21.967165,53.7516109 C22.6163028,54.0824308 23.3835153,54.0824308 24.0324711,53.7516109 L44.3766097,43.3854328 C45.3723303,42.8780537 45.9998181,41.8514154 45.9998181,40.7297348 L45.9998181,12.9563975 C45.9998181,12.3017031 45.6401361,11.700744 45.0644993,11.3938674 L24.3186521,0.329677583 C23.4941307,-0.109892528 22.5058693,-0.109892528 21.681166,0.329677583 Z",
    id: "Path",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,54 C23.3540421,54 23.7082661,53.9173864 24.0326531,53.7519764 L44.3767916,43.3857983 C45.3725123,42.8784193 46,41.8517809 46,40.7301003 L46,12.9563975 C46,12.66725 45.926499,12.390531 45.7985999,12.1430558 L23,24.3419031 L23,54 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24.3419031 L0.201582028,12.142873 C0.0735010283,12.3903482 0,12.6670672 0,12.9562148 L0,40.7297348 C0,41.8515981 0.627487739,42.8780537 1.62320835,43.3854328 L21.967165,53.7516109 C22.2917339,53.9170209 22.645776,53.9996345 23,53.9996345 L23,24.3419031 L23,24.3419031 Z",
    id: "Path",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1282313,3.96120295 L8.05509413,16.305538 L8.05509413,20.2554546 C8.05509413,20.6345267 8.26322576,20.9827101 8.59616358,21.161097 L12.6059722,23.3081365 C12.9241734,23.4784814 13.3082345,23.2469074 13.3082345,22.8846505 L13.3082345,19.1981103 L36.4172125,6.78194537 L31.1282313,3.96120295 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.3237, 40.1102)",
    fill: "#F41381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.00809324 L6.15534726,3.0506363 C6.94348204,2.67211251 7.43706692,1.86407116 7.41632653,0.986758672 L7.41578073,0.959342657 C7.39867901,0.235559856 6.63383167,-0.221190957 5.99269894,0.10962896 L0.000181933238,3.20142438 L0.000181933238,6.00809324 L0,6.00809324 L0,6.00809324 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.3204497 L3.38013764,8.74293214 C4.18046195,8.36916047 4.68459896,7.55472204 4.66367663,6.66827089 L4.66367663,6.66827089 C4.64657491,5.94192926 3.87736118,5.48536122 3.23586458,5.82093324 L0,7.51341525 L0,10.3204497 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.0549122,16.3451998 L8.0549122,20.2554546 C8.0549122,20.6345267 8.26304382,20.9827101 8.59598165,21.161097 L12.6057902,23.3081365 C12.9239915,23.4784814 13.3080525,23.2469074 13.3080525,22.8846505 L13.3080525,19.1981103 L13.3471682,19.1770914 C11.9890365,18.4503842 9.78309603,17.2698506 8.0549122,16.3451998 Z",
    id: "Path",
    fill: "#07A0C9"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailing116X116);
export default __webpack_public_path__ + "static/media/mailing_116x116.c6d0dc5ee3927a8d092970207fadbafd.svg";
export { ForwardRef as ReactComponent };